module.exports = __webpack_public_path__ + "img/candy_404.58ad567b.webp";